<template>
  <div class="loading-circle" v-if="loading">
    <v-progress-circular
      :size="60"
      color="primary"
      indeterminate
    ></v-progress-circular>
  </div>
  <v-container v-else class="user-profile">
    <v-row>
      <v-col sm="3" class="left-side text-sm-center">
        <img class="pt-5 px-5" src="@/assets/img/avatar_placeholder.png" alt="avatar"> <!-- TODO: change for real data -->
        <v-btn v-if="isMyProfile">
          Settings
        </v-btn>
        <v-btn v-else dark color="kazan">
          Direct message
        </v-btn>
      </v-col>
      <v-col sm="8" offset-sm="1" class="right-side">
        <h1 class="pt-5">{{user.name.prefix}} {{user.name.first}} {{user.name.middle}} {{user.name.last}} {{user.name.suffix}}</h1>
        <h2><a :href="`/#/companies/${user.company.id}`">{{user.company.name}}</a></h2>
        <h4 class="grey--text">
          {{user.position}}
        </h4>
        <v-card class="mt-5">
          <div class="card-header pa-2">
            <v-icon>email</v-icon>
            <span>Emails</span>
          </div>
          <div class="pa-2" v-for="(item, index) in user.emails" :key="index">
            {{item.value}} <span class="grey--text">({{item.type}})</span>
            <span v-if="isMyProfile" class="privacy-icon">
              <v-icon small v-if="item.public">public</v-icon>
              <v-icon small v-else>fas fa-lock</v-icon>
            </span>
          </div>

        </v-card>

        <v-card class="mt-3">
          <div class="card-header pa-2">
            <v-icon>phone</v-icon>
            <span>Phones</span>
          </div>
          <div class="pa-2" v-for="(item, index) in user.phoneNumbers" :key="index">
            {{item.value}} <span class="grey--text">({{item.type}})</span>
            <span v-if="isMyProfile" class="privacy-icon">
              <v-icon small v-if="item.private">fas fa-lock</v-icon>
              <v-icon small v-else>public</v-icon>
            </span>
          </div>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { userService } from '@/_services'

export default {
  name: 'UserProfile',
  components: {},
  props: {},
  data () {
    return {
      userID: '',
      user: null,
      loading: true
    }
  },
  computed: {
    ...mapState(['cognito']),
    isMyProfile () {
      return this.userID === this.cognito.user.username
      // return true
    }
  },
  methods: {
    async fetchData () {
      this.userID = this.$router.currentRoute.params.userID
      this.user = await userService.getUser(this.userID)
      this.loading = false
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style lang="scss" scoped>
  .user-profile {
    .left-side {
      img {
        width: 100%;
      }
    }
    .right-side {
      a {
        text-decoration: none;

        &:hover {
          color: var(--v-kazan-base)
        }
      }
    }

    .card-header {
      background-color: var(--v-secondary-base);

      span {
        padding-left: 5px;
        font-size: 18px;
      }
    }

  }

</style>
